import { gql } from "@apollo/client";

export const GET_TASKS = gql`
  query GetTasks($filter: TaskFilterInput, $page: Int, $limit: Int) {
    getTasks(filter: $filter, page: $page, limit: $limit) {
      success
      message
      data {
        id
        task_key
        action_uri
        remediation_steps
        domains {
          key
          title
        }
        title
        description
        task_type_key
        status_key
        status_title
        progress_data
        priority
        task_owner_id
        task_owner_data {
          id
          email
          name
          first_name
          last_name
        }
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const UPDATE_TASK_OWNER_BULK = gql`
  mutation UpdateTaskOwnerBulk($task_ids: [Int!]!, $task_owner_id: String) {
    updateTaskOwnerBulk(task_ids: $task_ids, task_owner_id: $task_owner_id) {
      success
      message
      updated
      failed
      results {
        success
        message
        taskId
      }
    }
  }
`;
